import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "./Testimonial.css"; // Import custom styles

const Testimonial = () => {
  const swiperRef = useRef(null);

  const testimonials = [
    {
      id: 1,
      review: `"The team at Owision is highly professional and detail-oriented. They exceeded our expectations in every aspect of the project."`,
      author: "Amit Walia CEO of FWA-UK",
    },

    {
      id: 2,
      review: `"Owision transformed our digital presence! Their expertise in web development and design helped us create a stunning, high-performing website. The team was highly responsive, delivering everything on time and beyond expectations. Highly recommended!"`,
      author: " Nimit Agarwal- Techstack global",
    },

    {
      id: 3,
      review: `"Exceptional service with outstanding results. The website redesign significantly improved our online presence."`,
      author: "Naveen disoza- Comtech gold",
    },
    {
      id: 4,
      review: `"The team at Owision is highly professional and detail-oriented. They exceeded our expectations in every aspect of the project."`,
      author: "Amit Walia CEO of FWA-UK",
    },

    {
      id: 5,
      review: `"Owision transformed our digital presence! Their expertise in web development and design helped us create a stunning, high-performing website. The team was highly responsive, delivering everything on time and beyond expectations. Highly recommended!"`,
      author: " Nimit Agarwal- Techstack global",
    },

    {
      id: 6,
      review: `"Exceptional service with outstanding results. The website redesign significantly improved our online presence."`,
      author: "Naveen disoza- Comtech gold",
    },
  ];

  const handlePrev = () => {
    if (swiperRef.current) swiperRef.current.slidePrev();
  };

  const handleNext = () => {
    if (swiperRef.current) swiperRef.current.slideNext();
  };

  return (
    <div className="testimonial-container">
      <div className="heading-tag">
        <h1 className="text-[20px] md:text-[24px]">What People Say</h1>
        <h1 className="text-[20px] md:text-[24px]"> About Us</h1>
      </div>
      <div className="slider-wrapper">
        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={30}
          slidesPerView={1}
          autoplay={{ delay: 4000 }}
          loop={true}
          onSwiper={(swiper) => (swiperRef.current = swiper)}
        >
          {testimonials.map((item) => (
            <SwiperSlide key={item.id}>
              <div className="testimonial-card">
                <p className="testimonial-review">{item.review}</p>
                <p className="testimonial-author">— {item.author}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="btm-grp-content">
          <button className="nav-btn prev-btn" onClick={handlePrev}>
            &#x2190;
          </button>
          <button className="nav-btn next-btn" onClick={handleNext}>
            &#x2192;
          </button>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
